@if (modalIsOpen) {
  <div class="z-10 text-xs bg-sky-200 rounded-lg mt-2">
    <button type="button" class="float-right">
      <span style="color: black !important; font-size: 20px" aria-hidden="true" (click)="closeModal()">&times;</span>
    </button>
    <p class="px-2 pt-3 mb-1">{{ "global.alert" | translate }}</p>
    @for (alerts of alertMaps.get(property); track alerts; let index = $index) {
      <ul class="px-2 pb-1 mb-1">
        <p class="m-0">{{ getSectionTitleKey(property, index) | translate }}</p>
        @for (a of alerts; track a) {
          <li class="pl-2" style="list-style: inside !important">{{ "" + a + "" | translate }}</li>
        }
      </ul>
    }
  </div>
}
